export const FACILITY_ID = 'FACILITY_ID';

export const listOfFacilityRegions = ['East', 'Delta', 'West'];

export const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export const GROUP_ID = 'GROUP_ID';
